import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { PatientImmunization } from '@/types/patient-chart-api';

/**
 * Patient immunizations list — Chart > Immunizations tab (PROD-736 PR D).
 *
 * Wire (Flutter `patient_chart_data_source_impl.dart:643`):
 *
 *   GET /api/Patients/GetImmunizationByPatientId?PatientId={id}
 *       → PatientImmunization[]
 *
 * Flat array; tombstones (`isDeleted: true`) included and filtered
 * client-side, same pattern as Allergies + Problems + Procedures.
 */

export function usePatientImmunizations(patientId: string | null | undefined) {
  return useQuery({
    queryKey: ['patient-immunizations', patientId],
    queryFn: ({ signal }) => {
      const qs = new URLSearchParams({ PatientId: patientId ?? '' });
      return get<PatientImmunization[]>(
        `/api/Patients/GetImmunizationByPatientId?${qs.toString()}`,
        { signal },
      );
    },
    enabled: !!patientId,
    staleTime: 60_000,
  });
}
